export const allowZero = (value) => {
  if (value === null || value === undefined) {
    return "N/A";
  }

  return value;
};
